import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-detail-not-found',
    imports: [
        CommonModule,
        ButtonModule
    ],
    templateUrl: './detail-not-found.component.html',
    styleUrl: './detail-not-found.component.scss'
})
export class DetailNotFoundComponent implements OnInit {

  ref?: DynamicDialogRef;
  sequenceMsg?: string;
  sequenceDetails?: any;
  flightMsg?: string;
  flightDetails?: any;

  constructor(
    private config: DynamicDialogConfig,
    private dialogService: DialogService,
    public appService: AppService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const details = this.config.data;
    if (details.id === 'seq') {
      this.sequenceMsg = `The sequence details listed below 
      are not valid or do not exist. Please check and try again.`;
      this.sequenceDetails = details.data;
    }
    else {
      this.flightMsg = `The flight details listed below 
      are not valid or do not exist. Please check and try again.`;
      this.flightDetails = details.data;
    }
  }

  onConfirm() {
    this.dialogService.dialogComponentRefMap.forEach((dialog) => {
      dialog.destroy();
    });
    this.router.navigate(['flights']);
  }
}
